import { useSelector } from 'react-redux';
import type { RootState } from '../Redux';
import type { Rights } from '../Utils/types';

export const NO_RIGHTS: Rights = { read: false, update: false, delete: false };

const selectFeaturePermissions = (state: RootState) => state.permission.featurePermissions;
export const useFeaturePermissions = () => useSelector(selectFeaturePermissions);

const selectFeaturePermissionsLoaded = (state: RootState) => state.permission.featurePermissionsLoaded;
export const useFeaturePermissionsLoaded = () => useSelector(selectFeaturePermissionsLoaded);
